<template>
  <div class="c-app">
   <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'ReportsContainer'
}
</script>
